<template>
    <modal :title="$t('public.escalation_rules')" :visible.sync="isShowDialog" width="600px">
        <el-form ref="form" label-width="160px" :model="dioForm" :rules="rules">
          <!-- 上报规则 -->
          <el-form-item :label="$t('device.sample_interval')" prop="collectInterval">
              <el-input v-model.trim="dioForm.collectInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
          </el-form-item>
          <!-- 二氧化碳参数有些不用 -->
          <template v-if="iscoz">
            <el-form-item :label="$t('device.normal_reporting_interval')" prop="normalReportInterval">
                <el-input v-model.trim="dioForm.normalReportInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('device.abnormal_reporting_interval')" prop="abnormalReportInterval">
                <el-input v-model.trim="dioForm.abnormalReportInterval" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
            <el-form-item :label="$t('device.time_zone')" prop="timeZone">
              <el-select v-model="dioForm.timeZone" style="width: 250px">
                  <el-option v-for="item in shiquArray" :key="item.code"
                      :label="`${$t(shiquArrayConvert(item.code))}`" :value="item.code"> </el-option>
              </el-select>
          </el-form-item>
          </template>
          <template v-else>
            <el-form-item :label="$t('integration.alarm_threshold')" prop="alarmThreshold">
                <el-input v-model.trim="dioForm.alarmThreshold" style="width: 250px" maxlength="50" :placeholder="$t('public.please_enter')" />
            </el-form-item>
          </template>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { sensorUpdateNetConfig, gasUpdateAppConfig } from '@/api/modules/sensor.js'
import addRules from '@/pages/equipment/validate/addRules.js'
import { shiquArrayConvert } from '@/utils/convert'
export default {
  name: 'NetParam',
  props: ['isShow', 'choozeTableData', 'useFuncType', 'shiquArray'],
  watch: {
    choozeTableData (newVal) {
      this.tableData = [...newVal]
    },
  },
  computed: {
    // 正则不会写啊  难搞
    rules () {
      return {
        collectInterval: [
            {
              required: true,
              message: $t('integration.collection_interval_cannot_be_empty'),
              trigger: 'blur'
            }
          ],
          alarmThreshold: [
            {
              required: true,
              message: $t('integration.alarm_threshold') + $t('integration.cannot_be_empty'),
              trigger: 'blur'
            }
          ],
          normalReportInterval: [
            {
              required: true,
              message: $t('device.normal_reporting_interval') + $t('integration.cannot_be_empty'),
              trigger: 'blur'
            }
          ],
          abnormalReportInterval: [
            {
              required: true,
              message: $t('device.abnormal_reporting_interval') + $t('integration.cannot_be_empty'),
              trigger: 'blur'
            }
          ],
          timeZone: [
            {
              required: true,
              message: $t('device.time_zone') + $t('integration.cannot_be_empty'),
              trigger: 'blur'
            }
          ]
      }
    },
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    iscoz(){
      return  this.tableData.length && this.tableData[0].type === 6
    },
    shiquArrayConvert: () => shiquArrayConvert,
  },
  data () {
    return {
      title: 'public.net_param',
      dioForm: {
        collectInterval: null,
        alarmThreshold: null,
        normalReportInterval: null,
        abnormalReportInterval: null,
        timeZone: null,
      },
      tableData: []
    }
  },
  mounted () {},
  methods: {
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async handleSave () {
      const flag = await this.justify()
      if (!flag) return
      const idList = this.tableData.map(item => item.id)
      const type = this.tableData[0].type
      const query = Object.assign({}, this.dioForm, { idList })
      // 默认网络参数url
      let httpUrl = gasUpdateAppConfig

      // 去除null
      for (const key in query) {
        if (query[key] === null) {
          delete query[key]
        }
      }
      httpUrl(query).then(({ state }) => {
        if (state.code === 200) {
          this.$message.success($t('integration.update_successful'))
          this.isShowDialog = false
          this.$parent.getListFn()
        } else {
          this.$message.error(state.msg)
        }
      })
    }
  }
}
</script>

<style></style>
